import { render, staticRenderFns } from "./ClaimData.vue?vue&type=template&id=f6e5e9a8&"
import script from "./ClaimData.vue?vue&type=script&lang=js&"
export * from "./ClaimData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports